import WinterImage from './WinterImage';

export default WinterImage;